import { initializeApp } from 'firebase/app';
import { MessagePayload, getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyB35e4SWZUWAY5OZVtVvyWfdCSXwEDUTt8",
    authDomain: "pom-safe-2.firebaseapp.com",
    projectId: "pom-safe-2",
    storageBucket: "pom-safe-2.appspot.com",
    messagingSenderId: "209062764841",
    appId: "1:209062764841:web:8ce980789d58a041861738",
    measurementId: "G-PMGMYQPQ6W"
};
  
// Initialize Firebase
initializeApp(firebaseConfig);

export const messaging = getMessaging();

export const requestFbPushForToken = () => {
    return getToken(messaging, { vapidKey: 'BOcsy-dQrMDr61anBwhOc4VCstzAZ88r7IdnVAD0lK7akmdgzqm5A4ZPVVcKadbOc6OP9o1FQHJP7wHCSXygrUU' })
        .then((currentToken) => {
            if (currentToken) {
                return currentToken;
            } else {
                return null;
            }
        })
        .catch((err) => {
            return null;
        });
};

export const onMessageListener = (): Promise<MessagePayload> =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });